import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Principal from './Components/Inicial/Principal';
import Login from './Components/Login/Login';
import { UserStorage } from './UserContext';
import ProtectedRoute from './Components/Helper/ProtectedRoute';

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <UserStorage>
          <Routes>
            <Route path="*" element={<Login />} />
            <Route
              path="/home/*"
              element={
                <ProtectedRoute>
                  <Principal />{' '}
                </ProtectedRoute>
              }
            />
          </Routes>
        </UserStorage>
      </BrowserRouter>
    </div>
  );
}

export default App;
